/* tslint:disable */

/**
 */
export class VehicleForm {
    id?: number;
    comany_id?: number;
    route_id?: number;
    is_running?: number;
    license_plates?: string;
    rfid?: string;
    device_imei?: string;
    bluetooth_mac_add?: string;
    bluetooth_pass?: string;
    active?: boolean;
}
